import styled from "styled-components";
import {
  blackAlpha008,
  lightInactive,
  trInputBackground,
  secondaryColor,
  accent,
  greyDark,
  onHoverDropShadow,
} from "../variable";
import { Spinner } from "@chakra-ui/react";

export const StyledAiTemplate = styled.div`
  display: flex;
  flex-direction: row;
  // align-items: flex-start;
  border: 3px solid ${blackAlpha008};
  border-radius: 8px;
  padding: 12px; // TODO: Padding should change using media query
  background: ${trInputBackground};

  &:hover {
    cursor: pointer;
    border: 3px ${greyDark} solid;
    box-shadow: 0px 0px 40px ${onHoverDropShadow};
    -webkit-box-shadow: 0px 0px 40px ${onHoverDropShadow};
    -moz-box-shadow: 0px 0px 40px ${onHoverDropShadow};
  }

  .icon {
    &.new-document-icon {
      font-size: 34px;
      margin: 2px 0px 0px 8px;

      svg {
        display: inline-block;
      }

      .fa-pencil-alt {
        font-size: 30px;
      }
    }
  }

  .info-container {
    display: flex;
    flex-direction: column;
    margin-left: 1rem;
  }

  .title {
    font-weight: 500;
    margin-top: 5px;
    width: 100%;
    color: ${lightInactive};
    font-size: 16px;
  }

  .title2 {
    font-weight: 400;
    margin-top: 5px;
    width: 100%;
    color: ${lightInactive};
    font-size: 16px;
    word-break: break-word;

    display: -webkit-box;
    -webkit-line-clamp: 6;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .subtitle {
    font-weight: normal;
    color: #888888;
    font-size: 14px;
    letter-spacing: 0;

    &.description {
      display: block;
      display: -webkit-box;
      max-width: 100%;
      height: 60px;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
`;

export const StyledAiRow = styled(StyledAiTemplate)`
  margin-top: 1px;
  border-radius: 8px;
  border: unset;
  border: 3px solid #323232;
  ${(allowOverflow) => (!allowOverflow ? "overflow: hidden;" : "")};
  background-color: #232323;
  padding: unset !important;
  min-height: 170px;

  :hover {
    box-shadow: 0px 0px 40px ${onHoverDropShadow};
    -webkit-box-shadow: 0px 0px 40px ${onHoverDropShadow};
    -moz-box-shadow: 0px 0px 40px ${onHoverDropShadow};
  }

  .thumbnail {
    position: relative;
    height: 100%;
    width: 100%;
    padding: 12px;

    .document-action {
      position: absolute;
      top: 20px;
      right: 13px;

      svg {
        path {
          fill: ${lightInactive};
        }
      }
    }

    .favorite-action {
      position: absolute;
      top: 10px;
      right: 13px;
    }

    .title {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
`;

export const StyledCenterAlignedRow = styled(StyledAiRow)`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${lightInactive};
  min-height: 170px;
`;

export const StyledHeaderText = styled.div`
  font-size: 22px;
  font-weight: bold;
  line-height: 28px;
  justify-content: start;
  text-align: center;
  display: flex;
  align-items: center;
`;

export const StyledAIResultsListGroupItem = styled.div`
  background-color: rgba(0, 0, 0, 0.16);
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid ${blackAlpha008};
  border-radius: 8px;
  cursor: default;

  svg {
    cursor: pointer;
  }

  ${(props) =>
    props.hoverEnabled &&
    `
    :hover {
      border: 1px solid ${blackAlpha008};
      box-shadow: 0px 0px 40px ${onHoverDropShadow};
      -webkit-box-shadow: 0px 0px 40px ${onHoverDropShadow};
      -moz-box-shadow: 0px 0px 40px ${onHoverDropShadow};
    }

    &.active {
      background-color: unset;
      border: 1px solid ${accent};
      box-shadow: 0px 0px 40px ${onHoverDropShadow};
      -webkit-box-shadow: 0px 0px 40px ${onHoverDropShadow};
      -moz-box-shadow: 0px 0px 40px ${onHoverDropShadow};
    }
  `}
`;

export const StyledAiEditor = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;

  @media (max-width: 576px) {
    flex-direction: column;
  }

  .ai-box {
    width: 100%;

    .settings-card-body {
      border-radius: 8px;
    }
  }
`;

export const AIEditorPageStyle = {
  ".quill": {
    padding: "1rem",
    ".ql-container": {
      height: "auto !important",
      border: "unset",

      ".ql-tooltip.ql-editing": {
        ".ql-action": {
          color: "primary.200",
        },
      },
      ".ql-clipboard": {
        position: "fixed !important",
      },
      ".ql-editor": {
        "user-select": "text",
        height: "auto !important",
        "font-size": "1rem",
        "h1, h2, h3, h4, h5, h6": {
          color: "unset !important",
        },
        "p, span, h1, h2, h3, h4, h5, h6, b, i, u, s, li, sup, sub, blockquote, pre, br, strong":
          {
            "::selection": {
              color: "gray.600",
              backgroundColor: "primary.200",
            },
          },
        p: {
          span: {
            background: "none !important",
          },
        },
        ".ql-tooltip.ql-editing": {
          ".ql-action": {
            color: accent,
          },
        },
      },
    },
  },
};

export const StyledAiEditorWrapper = styled.div`
  .overlay {
    height: 100%;
    width: 100%;
    background-color: black;
    opacity: 0.4;
  }

  .toggle-adv-panel-button {
    position: fixed;
    top: 200px;
    right: 0;
    z-index: 101;
    background-color: ${secondaryColor};
    padding: 10px;
    border-radius: 8px 0 0 8px;
    color: ${lightInactive};

    :hover {
      cursor: pointer;
      color: ${accent};
    }
  }
`;

export const StyledSpinner = styled.div`
  position: absolute;
  top:${(props) => props.top ? props.top : "50%"};
  bottom:50%;
  left:${(props) => props.left ? props.left : "50%"};
  right:50%;
  color: ${accent};
  width:${(props) => props.width ? props.width : ""};
`;
